import { Component, OnInit } from "@angular/core";
import { LocalStorageService } from "ng2-webstorage";
import { NoticeboardService } from "../../../../../components/noticeboard/noticeboard/noticeboard.service";
import { initGoogleClient } from "../../../../../shared/googleAuth/googleAuthentication";
import { ConfirmationService } from 'primeng/primeng';
import { MessageService } from "primeng/components/common/messageservice";
import { addSemesterModel, addSemesterTestModel } from "../../../../../components/dataAnalytics/dataAnalytics.model";
import { DataAnalyticsService } from "../../../../../components/dataAnalytics/dataAnalytics.service";
import { stderr } from "process";
declare var gapi: any

@Component({
    selector: 'addSemesterS',
    templateUrl: 'addSemesterS.component.html',
    styleUrls: ['addSemesterS.component.scss'],

})
export class AddSemesterSComponent implements OnInit {

  AddSemesterModel = new addSemesterModel();
  AddSemesterTestModel = new addSemesterTestModel();
  display = "none";
  display1 = "none";
  display3 = "none";
  display4 = "none";
  display5 = "none";
  public schoolId: any;
  SemesterData: any = [];
  public semName: any;
  public semId: any;
  public desd: any;
  public TestData: any = [];
  public TestDataPayload: any = [];
  public mappedData: any;
  public newSectionArray = [];
  public adminUserFlag: boolean;
  public schoolUserFlag: boolean;
  public selectedStd = [];
  public userdetailes = [];
  public guru: any = [];
  public subName: any;
  public subId: any;
  public payload: any;
  public testvalues: any = [];
  public testvalues1: any = [];
  public SemesterTestMappingData: any = [];
  public editFlag: boolean = false;
  public Data: any = [];
  public YearData: any = [];
  public Es : boolean = false;
  public userId :string;

  public selectedsub: any;
  public selectedsec: any;
  public selectedgrade:  any;
  public selectedsection:  any;
  nameofsec: any = [];
  sectionId: any = []
  sectionList: any = [];
  selectedSubject: string = "All Subjects";
  subjects: any = [];
  subjectsList: any = [];
  public ShowLevelData: any;
  public selectedlevel: string = '';
  public selectedleveladd: string = '';


  constructor(private dataAnalyticsService: DataAnalyticsService, private messageService: MessageService,
              private noticeboardService: NoticeboardService, private confirmationService: ConfirmationService, private localStorage: LocalStorageService,
  ) {
    this.schoolId = this.localStorage.retrieve('SchoolId');
    this.userId = this.localStorage.retrieve('id');
  }
  ngOnInit() {
    this.getLevelsName();
    this.getSemesterData();
    this.adminUserFlag = this.localStorage.retrieve('IsSchoolAdminUser');
    this.schoolUserFlag = this.localStorage.retrieve('Isschooluser');
    this.getYearData();
    if (this.adminUserFlag || this.schoolUserFlag) {
      this.getClassSection();
    }

    else {
    }
    this.selectedStd = new Array<string>();

    if (this.adminUserFlag == true) {
      this.schoolUserFlag = false;
    }
  }

  private getYearData()
  {
    this.dataAnalyticsService.getYear()._finally(() => { }).subscribe(
      response => {
        this.YearData = response['yearList'];
        console.log(this.YearData )
      }
    )
  }

  // add year
  addSemesterYear(sec){
    this.SemesterData.filter(ele => {
      if (ele.Id == sec.SemesterId) {
        this.AddSemesterModel.Id = sec.SemesterId;
      }
    })
    this.AddSemesterModel.AcademicYearId = this.YearData[0].YearId;
    this.dataAnalyticsService.postSemesterYear(this.AddSemesterModel).finally(() => { }).subscribe(
      response => {
        console.log(response)
        this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: 'Semester Added for current year Successfully' });
        this.postSemesterTest1();
        // this.PostTestSectionsMapping()
        this.getSemesterData();
        this.GetSemesterTestMapping()
        this.display = "none";
      },
      error => {
        this.messageService.add({ severity: 'error', summary: 'Talkative Parents', detail: error['Message'] });
      }
    );
  }

  private getLevelsName() {
    this.dataAnalyticsService
      .getLevel()
      ._finally(() => {})
      .subscribe((response) => {
        this.ShowLevelData = response;
        try {
          this.selectedleveladd =  this.ShowLevelData[0].Id;
          this.selectedlevel =  this.ShowLevelData[0].Id;
          //this.getClassSection(this.selectedlevel["Id"]);
          this.getLevelClassSection(this.selectedleveladd);
          this.GetSemesterTestMapping()
        } catch (error) {

        }
        console.log("ShowLevelData", this.ShowLevelData);
      }, (error) => {

      });
  }

  getLevelsListById(){
    console.log(this.selectedleveladd);
    this.getLevelClassSection(this.selectedleveladd);
    this.GetSemesterTestMapping();
  }

  //------------------------Ex Grade 1,2,3, & A,B,C--------------------------------------------------------------

  private getLevelClassSection(lid) {
    this.dataAnalyticsService.GetLevelStandardSectionMapping(lid).finally(() => { }).subscribe(
      response => {
        let mappedData: any = response;
        mappedData.forEach(standard => {
          standard['Sections'].forEach(section => {
            section['StdId'] = standard['standardId'];
            section['StdName'] = standard['standardsName'];
            section['selected'] = false;
          });
        });
        console.log("mappedData", mappedData);
        mappedData.sort((a, b) => ("" + a.standardsName).localeCompare(b.standardsName, undefined, { numeric: true }));
        if (true) {
          this.mappedData = mappedData;

        }

        try {
          this.selectedgrade = mappedData[mappedData.length - 1];
          this.getSectionByGrade(this.selectedgrade);
          this.selectedsection = this.selectedgrade.Sections[0];
          //this.getSubjects();
        } catch (error) {
          //window.location.reload();
        }

        try {
          this.nameofsec = this.selectedsection.sectionName;
          this.sectionId = this.selectedsection.SectionId;
        } catch (error) {

        }


      },
      error => {
        this.mappedData = [];
        this.sectionList = [];
        this.subjectsList = [];
        this.selectedgrade = null;
        this.selectedsection = null;
        this.selectedSubject = null;
      });
  };

  getSectionByGrade(grade) {
    this.subjectsList = [];
    this.selectedSubject = null;
    this.sectionList = grade.Sections;
    try {
      this.selectedsection = this.sectionList[0];
      //this.getSubjects();
    } catch (error) {

    }
  }

  getGclClassesListById(section) {

    this.nameofsec = section.sectionName;
    this.sectionId = section.SectionId;
    //this.getStudentData(this.standardId,section.SectionId,this.yearId)
    this.selectedsec = section.SectionId
    console.log('getGclClassesListById', this.selectedsec);

    //this.getSubjects();
  }

  /***********************************************************************************************************************/

  addSemester() {
    this.guru = [];
    this.editFlag = false;
    this.testvalues1 = [];
    //for clearing checkbox
    this.Es = false
    this.mappedData.forEach(element => {
      element.selected = false;
      // console.log(element)
      element.Sections.forEach(element1 => {
        // console.log(element1)
        element1.selected = false;
      });
    });
    this.AddSemesterModel = new addSemesterModel();
    this.display = "block"
  }
  onCloseHandled() {
    this.display = "none";
  }

  // new post Semesters

  private postSemester() {
    this.AddSemesterModel.SchoolId = this.schoolId;
    this.AddSemesterModel.AcademicYearId = this.YearData[0].YearId;
    this.dataAnalyticsService.postSemester(this.AddSemesterModel).finally(() => { }).subscribe(
      response => {
        console.log(response)
        this.desd = response["id"];
        this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: 'Semester Added Successfully' });
        // this.display = "none";
        // console.log(response)
        this.postSemesterTest1();
        // this.PostTestSectionsMapping()
        this.getSemesterData();
        this.GetSemesterTestMapping()
        this.display = "none";
      },
      error => { }
    );
  }

  private getSemesterData() {
    this.dataAnalyticsService.getSemesters()._finally(() => { }).subscribe(
      response => {
        this.SemesterData = response;
        console.log(this.SemesterData)
      }
    )
  }

  // editSemester(sem) {
  //     console.log(sem)
  //     this.editFlag = true;
  //     this.SemesterData.filter(ele => {
  //         if (ele.SemesterId == sem.SemesterId) {
  //             this.AddSemesterModel.Name = sem.SemesterName;
  //             this.AddSemesterModel.Id = sem.SemesterId;
  //             this.semName = sem.SemesterName;
  //             this.semId = sem.SemesterId;
  //             this.display1 = "block";
  //         }
  //     })
  //     this.getTestData(sem.SemesterId)
  // }



  onCloseHandled1() {
    this.display1 = "none";
  }

  // new updatesemester
  private UpdateSemester() {
    this.AddSemesterModel.SchoolId = this.schoolId;
    this.dataAnalyticsService.updateSemester(this.AddSemesterModel).finally(() => { }).subscribe(
      response => {
        this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: 'Semester updated successfully' });
        this.display1 = 'none';
        this.PostTestSectionsMapping()
        this.getSemesterData()
        this.GetSemesterTestMapping()
        // console.log(response)
        // var value = response['Message'];
        // if (value == 'Semester updated successfully') {
        //   this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: value });
        // } else
        //   if (value == 'Subject is already mapped to a section') {
        //     this.messageService.add({ severity: 'error', summary: 'Talkative Parents', detail: value });
        //   }
        //   else
        //   if (value == 'Subject not updated') {
        //     this.messageService.add({ severity: 'error', summary: 'Talkative Parents', detail: value });
        //   }
      },
      error => {
        this.messageService.add({ severity: 'error', summary: 'Talkative Parents', detail: 'Semester is alreaddy mapped to a test' });
      }
    );
  }

  confirm(Id) {
    // console.log(Id)
    this.confirmationService.confirm({
      message: 'Are you sure that you want to perform this action?',
      accept: () => {
        this.DeleteSemester(Id);
      }
    });
  }

  public DeleteSemester(Id) {
    this.dataAnalyticsService.DeleteSemester(Id).finally(() => { }).subscribe(
      response => {
        this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: 'Semester Deleted Successfully' });
        this.getSemesterData();
        this.GetSemesterTestMapping()
      },
      error => {
        this.messageService.add({ severity: 'error', summary: 'Talkative Parents', detail: 'Semester is already mapped to a section' });
      }
    )
  }


  // Test code
  addTest() {
    // this.testvalues1 = [];
    this.name1 = [];
    this.AddSemesterTestModel = new addSemesterTestModel();
    this.display3 = "block"
  }
  onCloseHandled3() {
    this.display3 = "none";
  }

  // hi(data)
  // {
  //     this.testvalues1.push(data);
  //     console.log(this.testvalues1)

  // }
  name1
  // new post Semesters
  postSemesterTest() {
    console.log(this.name1)
    // this.hi(this.name1);
    this.testvalues1.push(this.name1)
    console.log(this.testvalues1)
    this.display3 = "none"
    // this.testvalues1.push(this.AddSemesterTestModel);
    // console.log(this.testvalues1);
    // console.log(i)
    // this.AddSemesterModel.SchoolId = this.schoolId;
    // this.dataAnalyticsService.postSemester(this.AddSemesterModel).finally(() => { }).subscribe(
    //     response => {
    //         console.log(response)
    //         this.desd = response["id"];
    //         this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: 'Semester Added Successfully' });
    //         // this.display = "none";
    //         this.getSemesterData();
    //         // console.log(response)

    // this.AddSemesterTestModel.SchoolId = this.schoolId;
    // this.AddSemesterTestModel.SemesterId = this.desd;
    // // this.testvalues = this.AddSemesterTestModel;
    // this.testvalues = this.AddSemesterTestModel
    // this.testvalues1.push(this.testvalues);
    // console.log(this.testvalues)
    // console.log(this.testvalues1)


    // this.dataAnalyticsService.postTest(this.AddSemesterTestModel).finally(() => { }).subscribe(
    //     response => {
    //         this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: 'Test for this semester Added Successfully' });
    //         this.display3 = "none";
    //         this.getSemesterData();
    //         this.getTestData(this.desd)
    //         console.log(response)
    //     },
    //     error => { }
    // );
    //     },
    //     error => { }
    // );
  }

  private postSemesterTest1() {
    // console.log("test")
    for (var i = 0; i < this.testvalues1.length; i++) {
      var payload = {

        Name: this.testvalues1[i],
        SemesterId: this.desd,
        SchoolId: this.schoolId,
        CreatedBy: this.userId,
        ModifiedBy: this.userId,
        StatusId: 1,
      }
      this.dataAnalyticsService.postTest(payload).finally(() => { }).subscribe(
        response => {
          this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: 'Test for this semester Added Successfully' });
          this.display3 = "none";
          this.getSemesterData();
          this.GetSemesterTestMapping()
          this.getTestData(this.desd)
          // console.log(response)
        },
        error => { }
      );
    }

  }

  addTestEdit(){
    this.AddSemesterTestModel = new addSemesterTestModel();
    this.display5 = "block"
  }

  onCloseHandled5() {
    this.display5 = "none";
  }

  postSemesterTestedit(){
    console.log(this.AddSemesterTestModel);
    var payload = {

      Name: this.AddSemesterTestModel.Name,
      SemesterId: this.semId,
      SchoolId: this.schoolId,

    }
    this.dataAnalyticsService.postTest(payload).finally(() => { }).subscribe(
      response => {
        this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: 'Test for this semester Added Successfully' });
        this.display5 = "none";
        this.getSemesterData();
        this.GetSemesterTestMapping()
        this.getTestData(this.semId)
        // console.log(response)
      },
      error => { }
    );

    // this.display5 = "none";
  }



  private getTestData(SemesterId) {
    this.dataAnalyticsService.getTest(SemesterId)._finally(() => { }).subscribe(
      response => {
        this.TestData = response['testsList'];
        console.log(this.TestData)
        // var obj = {

        //     "Tests": this.TestData
        // }
        // console.log(obj);
        // this.TestDataPayload = obj;
        // console.log(this.TestDataPayload);
        if (!this.editFlag)
          this.PostTestSectionsMapping()
      }
    )
  }

  editTest(test) {
    console.log(test);
    this.TestData.filter(ele => {
      if (ele.TestId == test.TestId) {
        this.AddSemesterTestModel.Name = test.TestName;
        this.AddSemesterTestModel.Id = test.TestId;
        this.display4 = "block";
      }
    })
  }

  onCloseHandled4() {
    this.display4 = "none";
  }

  // new updatesemester
  public UpdateSemesterTest() {
    this.AddSemesterTestModel.SchoolId = this.schoolId;
    this.dataAnalyticsService.updateTest(this.AddSemesterTestModel).finally(() => { }).subscribe(
      response => {
        this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: 'Test updated successfully' });
        this.display4 = 'none';
        // this.getTestData(this.desd)
        this.getTestData(this.semId)
        // this.getSemesterData()
      },
      error => {
        this.messageService.add({ severity: 'error', summary: 'Talkative Parents', detail: 'Test not found or is already mapped' });
      }
    );
  }

  // confirm1(Id) {
  //     debugger
  //     // console.log(Id)
  //     this.confirmationService.confirm({
  //         message: 'Are you sure that you want to perform this action?',
  //         accept: () => {
  //             this.DeleteSemesterTest(Id);
  //         }
  //     });
  // }

  DeleteSemesterTest(Id) {
    this.dataAnalyticsService.DeleteTest(Id).finally(() => { }).subscribe(
      response => {
        this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: 'Test Deleted Successfully' });
        // this.getSemesterData();
        this.getTestData(this.desd)
      },
      error => {
        this.messageService.add({ severity: 'error', summary: 'Talkative Parents', detail: 'Test not found or is already mapped' });
      }
    )
  }



  public get_userdetailes() {
    var id = this.localStorage.retrieve('Id');
    this.noticeboardService.getUserdetailbyId(id).subscribe(response => {
      this.userdetailes = response['selectedSbAccessPermission'];
      const isAdmin = this.userdetailes.some(u => u.Rank == 1);
      let result = this.mappedData.filter(m =>
        this.userdetailes.some(u => u.standardid === m.standardId && (u.Rank == 2 || u.Rank == 3)
        ));
      const sectionsResult = this.mappedData.filter(m => (
        this.userdetailes.some(u => !result.some(r => r.standardId === u.standardid) && u.Rank == 4 && m.Sections.some(s => s.SectionId === u.sectionid))
      )).map(m => ({
        ...m,
        Sections: m.Sections.filter(s => this.userdetailes.some(u => u.sectionid === s.SectionId))
      }));
      result = result.concat(sectionsResult);
      this.newSectionArray = result;
      console.log(result, 'result');
    })
  }
  //All data
  private getClassSection() {
    this.noticeboardService.getClassSectionMap().finally(() => { }).subscribe(
      response => {
        let mappedData: any = response;
        // console.log('mappeddata',mappedData)
        mappedData.forEach(standard => {
          standard['Sections'].forEach(section => {
            section['StdId'] = standard['standardId'];
            section['StdName'] = standard['standardsName'];
            section['selected'] = false;
          });
        });
        mappedData.sort((a, b) => ("" + a.standardsName).localeCompare(b.standardsName, undefined, { numeric: true }));
        if (this.adminUserFlag) {
          this.mappedData = mappedData;
          // this.priorityFlag = true;
        }
        else {
          this.mappedData = mappedData;
          this.get_userdetailes();
        }
      },
      error => {
      });
  };


  selectSingleStd(e, standardId, standardsName) {
    if (e.target.checked) {
      this.mappedData.forEach(element => {
        // console.log(element)
        if (element.standardsName == standardsName) {
          // this.selectedStd.push(element)
          element.Sections.forEach(childElement => {
            childElement.selected = true;
            // console.log(childElement)

            this.guru.push(
              {
                "standardId": standardId,
                "SectionName": childElement.sectionName,
                "SectionId": childElement.SectionId,
              })
            console.log(this.guru)

            var obj = {
              // "SubjectName": this.subName,
              // "SubjectId": this.subId,
              "Sections": this.guru
            }
            // console.log(obj)

            this.payload = obj;
            console.log(this.payload)

          });

        }
        // console.log(element)
      });
    } else {
      this.payload = [];
      this.guru = this.guru.filter(m => m.standardId != standardId);
      console.log(this.guru)
      var obj = {
        // "SubjectName": this.subName,
        // "SubjectId": this.subId,
        "Sections": this.guru
      }

      this.payload = obj;
      console.log(this.payload)
      if (this.selectedStd.length == 0) {

      }
    }
  }


  private PostTestSectionsMapping() {
    console.log(this.mappedData);

    this.mappedData.map(element => {
      element.checkFlag = true;
      element.selectedFlag = false;
      if (Array.isArray(element['Sections'])) {
        element['Sections'].forEach(e => {
          e['selected'] = true;
          this.selectedStd = [];
          // console.log(e)
          this.guru.push(
            {
              "SectionName": e.sectionName,
              "SectionId": e.SectionId,
            }
          )
        });
      }
    });

    console.log(this.guru);
    var payload1 = {
      "Tests": this.TestData,
      "Sections": this.guru,
      "CreatedBy": this.userId,
      "ModifiedBy": this.userId,
    }
    console.log("payload1", payload1)


    this.dataAnalyticsService.postTestSectionsMapping(payload1).finally(() => { }).subscribe(
      response => {
        console.log(response)
        this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: 'Section Tests Mapped Successfully' });
        // this.display3 = "none";
        // this.getSemesterData();
        // this.getTestData(this.desd)
        // console.log(response)
        this.GetSemesterTestMapping();
      },
      error => { }
    );
  }


  postSubjectsSections() {
    // console.log('test',  this.AddSemesterModel.Name)
    // console.log('name1',this.name1)
    // console.log('guru',this.guru)
    if (this.AddSemesterModel.Name == undefined || this.AddSemesterModel.Name == '' || this.name1 == undefined || this.guru.length == 0) {
      alert('Please Fill All The Fields');
    } else {
      this.postSemester()
    }

  }

  UpdateSubjectsSections() {
    this.UpdateSemester()
  }

  private GetSemesterTestMapping() {
    console.log(this.selectedleveladd);
    this.dataAnalyticsService.getSemesterTestMapping(this.selectedleveladd)._finally(() => { }).subscribe(
      response => {
        console.log(response)
        this.SemesterTestMappingData = response['Value'];
        console.log(this.SemesterTestMappingData)
        // this.SemesterTestMappingData.forEach(element => {
        //     console.log(element)
        //     element.Standards.forEach(element1 => {
        //         element1.Sections.forEach(element2 => {
        //             element2.Semesters.forEach(element3 => {
        //                 // console.log(element3)
        //             });
        //         });
        //     });
        // });

      }
    )
  }

  // editSection(sec){
  //     console.log(sec)
  //     this.mappedData.forEach(element => {
  //         element.Sections.forEach(element1 => {
  //             console.log(element1)
  //             if (this.guru.filter(w => w.StdId == element.standardId).length > 0) {
  //                 element1.selected = true;
  //               } else {
  //                 element1.selected = false;
  //               }
  //         });
  //     });
  //     console.log(this.mappedData)

  // }

  editSemester(sec) {
    this.guru = [];
    this.Data = [];
    this.display1 = "block";
    // console.log(sec)

    // console.log(sem)
    this.editFlag = true;
    this.SemesterData.filter(ele => {
      if (ele.SemesterId == sec.SemesterId) {
        this.AddSemesterModel.Name = sec.SemesterName;
        this.AddSemesterModel.Id = sec.SemesterId;
        this.semName = sec.SemesterName;
        this.semId = sec.SemesterId;
        this.display1 = "block";
      }
    })
    this.getTestData(sec.SemesterId)

    sec["Tests"].forEach(element => {
      // console.log(element["Stds"])
      this.Data = element["Stds"];
      // console.log(this.Data)
    });

    this.mappedData.forEach(element => {
      if (this.Data.filter(w => w.StandardId == element.standardId).length > 0) {
        // console.log(element)
        element.selected = true;
        element.Sections.forEach(ele => {
          // console.log(ele)
          this.guru.push(
            {
              "standardId": element.standardId,
              "SectionName": ele.sectionName,
              "SectionId": ele.SectionId,
            })
          // console.log(this.guru)

        });

        this.mappedData.forEach(element1 => {
          // console.log(element1)
          element1.Sections.forEach(element2 => {
            // console.log(element2)
            element2.selected = true;
          });
        });
      } else {
        element.selected = false;
        this.mappedData.forEach(element1 => {
          element1.Sections.forEach(element2 => {
            element2.selected = true;
          });
        });
      }
    });
    // console.log(this.mappedData)
  }



  verify(e, secId) {
    if (e.target.checked) {
      this.payload = [];
      this.guru = [];
      //   this.selectAllSectionFlag = false;
      this.mappedData.map(element => {
        element.selected = true;
        // element.selectedFlag = false;
        if (Array.isArray(element['Sections'])) {
          element['Sections'].forEach(e => {
            e['selected'] = true;
            // this.selectedStd = [];
            // console.log(e)
            this.guru.push(
              {
                "SectionName": e.sectionName,
                "SectionId": e.SectionId,
              }
            )

            console.log(this.guru)

            // var obj = {
            //   "SubjectName": this.Subjectname,
            //   "SubjectId": this.Subjectid,
            //   "Sections": this.guru
            // }
            // // console.log(obj)

            // this.payload = obj;
            // console.log(this.payload)
          });
        }
      });

    } else {
      this.payload = [];
      this.guru = [];
      this.mappedData.forEach(element => {
        element.selected = false;
        if (Array.isArray(element['Sections'])) {
          element['Sections'].forEach(e => {
            e['selected'] = false;
            element.selected = false;
          });
        }

      });
      console.log(this.guru)
      //   console.log(this.payload)
    }

  }

}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/course/AddSemesters/addSemesterS.component.ts